<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />基础信息<slot name="right"></slot></h3>
    <Row>
      <Col span="6">
        <ly-form-item label="分析单位：">{{name}}</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="风控服务：">安全运营报告</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="在线率：">{{ item.onlineRate }}%</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="上线率：">{{ item.activeaRate }}%</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="车辆总数：">{{ item.carTotal }}辆</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="离线总数：">{{ item.offlineTotal }}辆</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="在线总数：">{{ item.onlineTotal }}辆</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="上线总数：">{{ item.activeaTotal }}辆</ly-form-item>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  props:['name'],
  data() {
    return {
      item: {
        carTotal: 0,
        activeaTotal: 0,
        activeaRate: 0,
        onlineTotal: 0,
        onlineRate: 0,
        offlineTotal: 0,
      },
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countCar",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.item=res.data.data;
      });
    },
  },
  mounted() {},
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/jichuxinxi.vue